import React from 'react';

import Container from './Container.jsx';
import { default as _TypeConfig } from './TypeConfig.jsx';
import Utilities from '../utility/Utilities.jsx';

function Image(props) {
    const hasContent = !Utilities.isNullOrWhitespace(props.imageUrl);
    if (!props.builder) {
        if (!hasContent) {
            return null;
        }
        if (!props.forceVisibility && !Utilities.Config.getVisibility(props.config, 'Image')) {
            return null
        }
    }
    let height, style, width;
    if (props.config && props.config.config && props.config.config.Block) {
        let hasMaxWidth;
        style = Utilities.Config.getStyle(props.config.config.Block, undefined, (propName, propValue) => {
            if (!propValue || !propValue.value) {
                return false;
            }
            switch (propName) {
                case 'height':
                    height = propValue.value;
                    break;
                case 'maxHeight':
                    if (!height) {
                        height = propValue.value;
                    }
                    break;
                case 'maxWidth':
                    hasMaxWidth = propValue.value && propValue.value.length > 0;
                    if (!width) {
                        width = propValue.value;
                    }
                    break;
                case 'width':
                    width = propValue.value;
                    break;
            }
        });
        if (!hasMaxWidth) {
            style.maxWidth = '100%';
        }
    }
    const linkStyle = {};
    if (Utilities.isNullOrWhitespace(props.url)) {
        linkStyle.cursor = 'default';
    }
    let imageUrl;
    if (props.image && props.data && props.data.Constants && props.data.Constants.CdnUrl) {
        let checkSize = 320;
        if (height) {
            checkSize = parseFloat(height);
        }
        if (width && width > checkSize) {
            checkSize = parseFloat(width);
        }
        const sizes = [1920, 1600, 1366, 1024, 768, 640, 320]
        let size = sizes[sizes.length - 1];
        for (let i = sizes.length - 1; i >= 0; i--) {
            size = sizes[i]
            if (checkSize <= size) {
                break;
            }
        }
        let transform = props.transform || 'c_pad';
        imageUrl = `${props.data.Constants.CdnUrl}w_${size},h_${size},${transform}/${props.image.S3Id}.${props.image.Extension}`
    } else {
        imageUrl = props.imageUrl;
    }
    return (
        <Container
            builder={props.builder}
            className={props.className}
            config={props.config}
            style={{ fontSize: '0pt', lineHeight: '0pt' }}
            onClick={props.onClick}
            onDragEnter={props.onDragEnter}
            onDragStart={props.onDragStart}>
            <tr>
                <td>
                    {
                        hasContent &&
                        <a href={props.url || ''} style={linkStyle}>
                            <img
                                alt={props.alt || ''}
                                src={imageUrl}
                                style={style}
                                title={props.alt || ''} />
                        </a>
                    }
                    {
                        props.builder &&
                        <React.Fragment>
                            {
                                !hasContent &&
                                Utilities.Builder.emptyBlockPlaceholder()
                            }
                            {Utilities.Builder.dragOutline()}
                        </React.Fragment>
                    }
                </td>
            </tr>
        </Container>
    );
}

const TypeConfig = {
    panel: {
        block: () => {
            const group = 'block';
            return {
                group,
                label: 'Layout',
                options: [
                    {
                        display: 'Width',
                        fullWidth: true,
                        group,
                        name: 'width',
                        options: _TypeConfig.dropdown.measurement(),
                        type: 'measurement-slider'
                    },
                    {
                        display: 'Height',
                        fullWidth: true,
                        group,
                        name: 'height',
                        options: _TypeConfig.dropdown.measurement(),
                        type: 'measurement-slider'
                    },
                    {
                        display: 'Max Width',
                        fullWidth: true,
                        group,
                        name: 'maxWidth',
                        options: _TypeConfig.dropdown.measurement(),
                        type: 'measurement-slider'
                    },
                    {
                        display: 'Max Height',
                        fullWidth: true,
                        group,
                        name: 'maxHeight',
                        options: _TypeConfig.dropdown.measurement(),
                        type: 'measurement-slider'
                    }
                ]
            };
        },
        style: () => _TypeConfig.panel.layoutStyle('block', undefined, {}, { title: 'Image Alignment', value: 'center' }),
        visibility: () => {
            return {
                options: [
                    {
                        configurableDuringExport: () => true,
                        display: 'Artwork Image',
                        name: 'Image',
                        type: 'checkbox',
                        value: true,
                        visible: () => false
                    }
                ]
            };
        }
    }
};

export {
    Image as Component,
    TypeConfig
};